import { type PublicGlobalConfig } from '../../global-config/config-types/PublicGlobalConfig'
import { experimentsTrackEvent } from '../eventTracking/experimentsTrackEvent'
import { type ExperimentType } from '../model/Experiment.types'

import { experimentsCompeteraExperimentIsEnabled } from './experimentsCompeteraExperiment'

export const experimentsCompeteraTrackCompeteraEvent = (
  experiments: ExperimentType[],
  globalConfig: PublicGlobalConfig,
  eventName: string,
): void => {
  if (experimentsCompeteraExperimentIsEnabled(experiments)) {
    experimentsTrackEvent(globalConfig, eventName)
  }
}
